var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileProfilePlaceholder = function SvgMobileProfilePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 33,
    fill: "#252525",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M16 16.5q-2 0-3.4-1.444t-1.4-3.506 1.4-3.506T16 6.6t3.4 1.444 1.4 3.506-1.4 3.506T16 16.5m-9.6 9.9v-3.3q0-.79.416-1.495.418-.705 1.15-1.186a16 16 0 0 1 3.884-1.685q2.05-.584 4.15-.584t4.15.584 3.884 1.685q.732.447 1.15 1.168.416.723.416 1.513v3.3z"
  })));
};
export default SvgMobileProfilePlaceholder;